module.exports = __webpack_public_path__ + "static/media/feature-slideg7.45571aa7.jpg";